import React, { useState } from "react";
import Heading from "../../components/common/Typography/Heading";
import TextFiled from "../../components/common/InputField/TextFiled";
import MainButton from "../../components/common/MainButton/MainButton";
import AuxiliaryText from "../../components/common/Typography/AuxiliaryText";
import SpecialText from "../../components/common/Typography/SpecialText";
import FieldDropdown from "../../components/common/InputField/FieldDropdown";
import EstimatedHighToLowCostGraph from "./EstimatedHighToLowCostGraph";
import {
  publicMainHeaderOffsetClass,
} from "../Public/shared/publicLayoutSpec";

const HeroImage = () => {
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedSubservice, setSelectedSubservice] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [step, setStep] = useState(1);
  
  const services = [
    { name: "Air condition & Heating" },
    { name: "Bricklaying" },
    { name: "Handyman" },
    { name: "Waterproofing" },
    { name: "Plumber" },
    { name: "Electrician" },
    { name: "Carpentry" },
    { name: "Inspection & Surveying" },
    { name: "Air condition & Heating" },
    { name: "Bricklaying" },
    { name: "Handyman" },
    { name: "Waterproofing" },
    { name: "Plumber" },
    { name: "Electrician" },
    { name: "Carpentry" },
    { name: "Inspection & Surveying" },
  ];

  const subservices = [
    { name: "Ceiling Fan Installation" },
    { name: "Light Fixture Replacement" },
    { name: "Electrical Outlet Installation" },
    { name: "Circuit Breaker Replacement" },
    { name: "Wiring Installation" },
    { name: "Electrical Panel Upgrade" },
    { name: "Ceiling Light Installation" },
    { name: "Security System Installation" },
  ];

  const locations = [
    { name: "Melbourne" },
    { name: "Sydney" },
    { name: "Brisbane" },
    { name: "Perth" },
    { name: "Adelaide" },
    { name: "Gold Coast" },
    { name: "Newcastle" },
    { name: "Canberra" },
    { name: "Sunshine Coast" },
    { name: "Central Coast" },
  ];
  return (
    <>
      <div className={publicMainHeaderOffsetClass()}>
        <div className="tp-container-fluid mx-auto">
          <div className="w-full h-auto relative rounded-xl bg-no-repeat bg-center bg-cover bg-about">
            <div className="tp-container-main mx-auto w-full">
              <div className="flex flex-col gap-20">
                <div className="h-[800px] flex flex-col lg:flex-row lg:items-center lg:justify-between gap-20">
                  <div>
                    <Heading
                      variant={"h1"}
                      className={"text-white text-center lg:text-start"}
                    >
                      Get a quick estimate before you commit
                    </Heading>
                  </div>
                <form className="flex justify-center lg:justify-end">
                  <div className="flex justify-center items-center bg-white p-10 rounded-xl w-full max-w-[480px] sm:w-[480px] h-[540px] mt-10 lg:mt-0">
                    <div className="w-full sm:w-[480px]">
                      <div>
                        <FieldDropdown
                          label="Select service to estimate"
                          variant="medium"
                          value={selectedRole}
                          onChange={(e) => setSelectedRole(e.value)}
                          options={services}
                          optionLabel="name"
                          placeholder="e.g., Lighting Replacement"
                        />
                      </div>
                      <div className="mt-5">
                        <FieldDropdown
                          label="Select subservices from the list"
                          variant="medium"
                          value={selectedSubservice}
                          onChange={(e) => setSelectedSubservice(e.value)}
                          options={subservices}
                          optionLabel="name"
                          placeholder="e.g., Ceiling Fan Installation"
                        />
                      </div>
                      <div className="mt-5 ">
                        <FieldDropdown
                          label="Choose your location"
                          variant="medium"
                          value={selectedLocation}
                          onChange={(e) => setSelectedLocation(e.value)}
                          options={locations}
                          optionLabel="name"
                          placeholder="e.g., Melbourne"
                        />
                      </div>
                      <div className="mt-32 flex justify-end">
                        <MainButton variant={"small"} onClick={() => setStep(2)}>
                          Estimate
                        </MainButton>
                      </div>
                      
                    </div>
                  </div>
                </form>
              </div>
              <div>
                <EstimatedHighToLowCostGraph />
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default HeroImage;
